import { useHasWIVOrEIVAccess } from '@frontend/insurance-verification';
import { breakpoints, useMatchMedia } from '@frontend/responsiveness';
import { useScopedAppFlagStore } from '@frontend/scope';

const INSURANCE_ELIGIBILITY_COVERAGE_WIDGET_FF = 'Insurance-eligibility-coverage-widget';

export const useShowInsuranceEligibilityCoverageWidget = () => {
  const isSmallMode = useMatchMedia({ maxWidth: breakpoints.mobile.max });
  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const isInsuranceEligibilityCoverageWidgetEnabled = getFeatureFlagValue(INSURANCE_ELIGIBILITY_COVERAGE_WIDGET_FF);
  const { isEIVFeatureHiddenInAllLocation: isWIEFeatureHiddenInAllLocation } = useHasWIVOrEIVAccess();

  return isInsuranceEligibilityCoverageWidgetEnabled && !isSmallMode && !isWIEFeatureHiddenInAllLocation;
};
